<template>
  <hm-content>
    <el-table
      stripe
      ref="attrTable"
      :data="specificationDetails.records"
      style="width: 100%"
      id="table"
      size="small"
      border
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column header-align="center" align="center" prop="typeName" label="规格类型"></el-table-column>
      <el-table-column header-align="center" align="center" prop="specName" label="规格名称"></el-table-column>
      <el-table-column header-align="center" align="center" prop="valueName" label="规格值"></el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="specificationDetails.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["specificationDetails"]),
  created() {
    this.$store.dispatch("querySpecificationDetails", {
      typeId: this.$route.query.id,
      pageSize: this.pageSize,
      pageNo: this.currentPage
    });
  },
  mounted() {},
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
